import { render, staticRenderFns } from "./EditCustomer.vue?vue&type=template&id=36e68c76&scoped=true&"
import script from "./EditCustomer.vue?vue&type=script&lang=js&"
export * from "./EditCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e68c76",
  null
  
)

export default component.exports